module.exports = __webpack_public_path__ + "img/wechat_code.7ede4e30.jpg";